export default {
    props: {
        excelFileName: {
            type: String,
            default: undefined,
            kComposite: 'excel.fileName'
        }, 
        excelFilterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.filterable'
        }, 
        excelForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.forceProxy'
        }, 
        excelProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'excel.proxyURL'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/KendoPivotGrid/Excel.js